// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-snap-type: y mandatory !important;
}

.AforismosFooter {
  display: grid;
  grid-template-rows: 1fr;
  align-items: center;
  height: 100dvh;
}

.AforismosFooter h1 {
  align-self: center;
  justify-self: center;
  color: white;
}

.TheorySection {
  scroll-snap-align: start;
  perspective: 500px;
  height: 100dvh;
}

.TheorySection > div {
  overflow: hidden;
}

.TheorySection h1 {
  font-size: 18px;
  font-weight: bolder;
  margin: 0;
}

.TheorySection p {
  font-size: 18px;
  font-weight: normal;
  margin: 0;
}

.TheoryAforismoSection {
  scroll-snap-align: start;
  perspective: 500px;
  height: 100dvh;
}

.TheoryAforismoSection > div {
  overflow: hidden;
}

.TheoryAforismoSection h1 {
  font-size: 18px;
  font-weight: bolder;
  margin: 0;
}

.TheoryAforismoSection p {
  margin: 0;
}

.Aforismo1_img_info h1 {
  font-size: 18px !important;
}

.Aforismo1_img_info p {
  font-size: 18px !important;
}

.Theory__Aforismos2 p {
  font-size: 18px;
  margin: 0;
}

.Theory__Aforismos2 {
  min-height: 100dvh;
  min-width: 100dvw;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.Starting-screen {
  height: 100dvh;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  display: grid;
  justify-content: center;
  align-items: center;
}

.Starting-screen h1 {
  color: white;
  font-size: 18px;
  font-weight: bolder;
}

.Aforismo1 {
  height: 200dvh;
}

.Aforismo1_elements {
  height: 100dvh;
  width: 100dvw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: left;
  align-items: center !important;
}

.Aforismo1_animation {
  color: white;
  border-left: 1px solid white;
  grid-row: 1 / 2;
  grid-column: 2 / 3;
  justify-self: left;
  align-self: self-start;
  height: 97.5%;
  width: 1px;
}

.Aforismo1_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo1_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo1_img {
  height: 100dvh;
  width: 100dvw;
  position: relative;
  overflow: hidden;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0.2) 15%,
    rgba(0, 0, 0, 0.15) 50%,
    rgba(0, 0, 0, 0.2) 85%,
    rgba(0, 0, 0, 0.45) 100%
  );
  pointer-events: none; /* This ensures that the overlay doesn't interfere with mouse events */
}

.Aforismo1_img img {
  object-fit: cover;
  object-position: 50% 90%;
  height: 100%;
  width: 100%;
}

.Aforismo1_img_info {
  color: White;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 15.7%;
  height: 100vh;
  align-items: end;
  padding-bottom: 1.5em;
  z-index: 100;
}

.Aforismo1_img_info h1 {
  grid-column: 3 / 5;
  grid-row: 1 / 2;
  width: 100%;
}

.Aforismo1_img_info p {
  grid-column: 3 / 5;
  grid-row: 1 / 2;
  width: 100%;
}

.Aforismo2_animation {
  color: white;
  max-height: 325px;
  height: 100%;
  width: auto;
  grid-row: 1 / 2;
  grid-column: 1 / 3;
  justify-self: center;
  align-self: self-end;
  position: relative;
  top: 3.15em;
  left: 5.6em;
  margin-right: 20px;
}

.teste {
  grid-row: 2 / 3;
  grid-column: 2 / 5;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  align-self: flex-start;
}

.Aforismo2_text_title {
  color: white;
  grid-column: 1 / 2;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo2_text_body {
  color: white;
  grid-column: 2 / 4;
  grid-row: 1 / 2;
  align-self: self-start;
}

.Aforismo3_elements {
  height: 100dvh;
  width: 100dvw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: left;
  align-items: center !important;
}

.Aforismo3_line {
  background-color: white;
  grid-row: 1 / 2;
  grid-column: 2 / 3;
  justify-self: right;
  max-height: 150px;
  height: 100%;
  max-width: 20px;
  width: 100%;
  position: relative;
  top: 1.2em;
  right: 7em;
}

.Aforismo3_animation {
  color: white;
  max-height: 190px;
  height: 100%;
  width: auto;
  grid-row: 1 / 2;
  grid-column: 2 / 4;
  justify-self: center;
}

.Aforismo3_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo3_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo3_img {
  height: 100dvh;
  width: 100dvw;
  position: relative;
  overflow: hidden;
}

.Aforismo3_img img {
  object-fit: contain;
  object-position: center;
  margin: 0 auto;
  height: 100%;
  width: 90%;
}

.Aforismo4_animation {
  color: white;
  height: 90%;
  width: auto;
  grid-row: 1 / 3;
  grid-column: 1 / 3;
  justify-self: right;
  align-self: center;
}

.Aforismo4_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo4_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo5 {
  height: 300dvh;
}

.Aforismo5_elements {
  height: 100dvh;
  width: 100dvw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: left;
  align-items: center;
}

.Aforismos5_animation_grid {
  grid-column: 3 / 5;
  grid-row: 1 / 3;
  color: white;
  width: -moz-fit-content;
  width: fit-content;
  height: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: left;
  align-items: baseline;
}

.Aforismo5_animation_1 {
  grid-column: 1 / 2;
  max-height: 133.85px;
  width: auto;
  align-self: baseline;
}

.Aforismo5_animation_2 {
  grid-column: 2 / 3;
  max-height: 133.85px;
  width: auto;
  align-self: baseline;
}

.Aforismo5_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo5_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo5_img {
  width: 100dvw;
  height: 100dvh;
  position: relative;
  overflow: hidden;
}

.Aforismo5_img img {
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
}

.Aforismo6 {
  height: 300dvh;
}

/* src/MouseParallax.css */
.mouse-parallax-container {
  height: 100dvh;
  width: 100dvw;
  z-index: 10;
  position: relative;
  top: 0;
  left: 0;
}

.background-blurred {
  position: relative;
  width: 100%;
  height: 100%;
  filter: blur(2px); /* Add a blur effect to the background */
}

.background-unblurred {
  position: relative;
  top: -100dvh;
  width: 100%;
  height: 100%;
  filter: none; /* No blur effect on the unblurred content */
}

.mouse-cursor {
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  pointer-events: none;
  transform: translate(-50%, -50%);
  border: 2px solid transparent; /* Set border initially to transparent */
  box-sizing: border-box; /* Ensure border is included in width and height */
  z-index: 100;
}

.Aforismo6_elements {
  height: 100dvh;
  width: 100dvw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: center;
  align-items: center;
}

.Aforismo6_animation {
  grid-column: 1 / 5;
  color: white;
  max-width: 209px;
  width: 100%;
  height: auto;
  justify-self: center;
  align-self: center;
}

.Aforismo6_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo6_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo6_img {
  height: 100dvh;
  width: 100dvw;
  position: relative;
  overflow: hidden;
}

.Aforismo6_img img {
  object-fit: contain;
  object-position: center;
  margin: 0 auto;
  height: 100%;
  width: 90%;
}

.Aforismo7 {
  height: 300dvh;
}

.Aforismo7_elements {
  height: 100dvh;
  width: 100dvw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: center;
  align-items: center;
}

.Aforismo7_animation {
  grid-column: 1 / 5;
  color: white;
  height: 300px;
  width: auto;
  justify-self: center;
}

.cursor {
  background-color: #ffffff;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  display: block !important;
}

.Aforismo7_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo7_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo7_img {
  width: 100dvw;
  height: 100dvh;
  position: relative;
  overflow: hidden;
}

.Aforismo7_img img {
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}

.Aforismo8 {
  height: 400dvh;
}

.Aforismo8_grid_title {
  grid-column: 2 / 4;
  grid-row: 2 / 3;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  height: 100%;
  justify-content: center;
  align-content: start;
}

.Aforismo8_title1 {
  grid-column: 1 / 2;
  color: white;
  justify-self: right;
}

.Aforismo8_title2 {
  grid-column: 2 / 3;
  color: white;
  justify-self: left;
}

.Aforismo8_animation1 {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  color: white;
  height: 150px;
  width: auto;
  justify-self: right;
  position: relative;
  right: 1.5em;
}

.Aforismo8_animation2 {
  grid-column: 3 / 4;
  grid-row: 1 / 2;
  color: white;
  height: 150px;
  width: auto;
  justify-self: left;
  position: relative;
  right: 3em;
}

.Aforismo8_text_title {
  color: white;
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo8_text_body {
  color: white;
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  align-self: self-start;
}

.Aforismo8_img {
  height: 100dvh;
  width: 100dvw;
  position: relative;
  overflow: hidden;
}

.Aforismo8_img img {
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}

.Aforismo9_animation {
  grid-column: 2 / 4;
  color: white;
  max-width: 650px;
  width: 100%;
  height: auto;
  justify-self: center;
  align-self: center;
}

.Aforismo9_img {
  height: 100dvh;
  width: 100dvw;
  position: relative;
  overflow: hidden;
}

.Aforismo9_img img {
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}

@media all and (min-width: 1921px) {
}

@media all and (min-width: 1441px) and (max-width: 1920px) {
}

@media all and (min-width: 1025px) and (max-width: 1440px) {
  .Aforismo1_elements {
    max-width: 80%;
  }

  .Aforismo3_elements {
    max-width: 80%;
  }

  .Aforismo5_elements {
    max-width: 80%;
  }

  .Aforismo6_elements {
    max-width: 80%;
  }

  .Aforismo7_elements {
    max-width: 80%;
  }
}

/* mobile */

@media all and (min-width: 769px) and (max-width: 1024px) {
  .TheorySection h1 {
    font-size: 21px;
    font-weight: bolder;
    margin: 0;
  }

  .TheorySection p {
    font-size: 21px;
    font-weight: normal;
    margin: 0;
  }

  .Aforismo1_elements {
    height: 100dvh;
    width: 100dvw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo1_animation {
    color: white;
    border-left: 1px solid white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: left;
    align-self: self-start;
    height: 75%;
    width: 1px;
  }

  .Aforismo1_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
    font-weight: bolder;
  }

  .Aforismo1_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo1_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo1_img img {
    object-fit: cover;
    object-position: 50% 90%;
    height: 100%;
    width: 100%;
  }

  .Aforismo1_img_info {
    color: White;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 5.25%;
    height: 100vh;
    align-items: end;
    padding-bottom: 1.5em;
    z-index: 100;
  }

  .Aforismo1_img_info div {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    width: 100%;
  }

  .Aforismo2_animation {
    color: white;
    max-height: 375px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: left;
    align-self: self-end;
    position: relative;
    top: -25px;
    left: -5.8em;
  }

  .teste {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    display: block;
    width: 100%;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    align-self: self-start;
  }

  .Aforismo2_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo2_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo3_line {
    background-color: white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: right;
    max-height: 150px;
    height: 100%;
    max-width: 20px;
    width: 100%;
    position: relative;
    top: 1.2em;
    right: 7em;
  }

  .Aforismo3_animation {
    color: white;
    max-height: 190px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: center;
  }

  .Aforismo3_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo3_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_img {
    height: 100dvh;
    width: 100dvw;
  }

  .Aforismo3_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 89.5%;
  }

  .Aforismo4_animation {
    color: white;
    height: 90%;
    width: auto;
    grid-row: 1 / 3;
    grid-column: 1 / 3;
    justify-self: right;
    align-self: center;
  }

  .Aforismo4_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo4_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .Aforismo5_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center;
  }

  .Aforismos5_animation_grid {
    grid-column: 1 / 3;
    color: white;
    width: -moz-fit-content;
    width: fit-content;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: left;
    align-items: baseline;
  }

  .Aforismo5_animation_1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_animation_2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo5_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo5_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo5_img img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo6_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo6_animation {
    grid-column: 1 / 5;
    color: white;
    max-width: 209px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }

  .Aforismo6_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo6_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo6_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo6_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 5%;
    height: 95%;
    width: 89.5%;
  }

  .Aforismo7_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo7_animation {
    grid-column: 1 / 3;
    color: white;
    height: 250px;
    width: auto;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: block !important;
  }

  .Aforismo7_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo7_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo7_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo7_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo8_grid_title {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    height: 100%;
    justify-content: center;
    align-content: center;
  }

  .Aforismo8_title1 {
    grid-column: 1 / 2;
    color: white;
    justify-self: right;
  }

  .Aforismo8_title2 {
    grid-column: 2 / 3;
    color: white;
    justify-self: left;
  }

  .Aforismo8_animation1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: right;
    position: relative;
    right: 2em;
  }

  .Aforismo8_animation2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: left;
    position: relative;
    right: 3em;
  }

  .Aforismo8_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo8_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo8_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo8_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo9_animation {
    grid-column: 1 / 3;
    color: white;
    max-width: 650px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }
}

@media all and (min-width: 426px) and (max-width: 768px) {
  .TheorySection h1 {
    font-size: 21px;
    font-weight: bolder;
    margin: 0;
  }

  .TheorySection p {
    font-size: 21px;
    font-weight: normal;
    margin: 0;
  }

  .Aforismo1_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo1_animation {
    color: white;
    border-left: 1px solid white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: left;
    align-self: self-start;
    height: 75%;
    width: 1px;
  }

  .Aforismo1_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
    font-weight: bolder;
  }

  .Aforismo1_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo1_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo1_img img {
    object-fit: cover;
    object-position: 50% 90%;
    height: 100%;
    width: 100%;
  }

  .Aforismo1_img_info {
    color: White;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 5.25%;
    height: 100vh;
    align-items: end;
    padding-bottom: 1.5em;
    z-index: 100;
  }

  .Aforismo1_img_info div {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    width: 100%;
  }

  .Aforismo2_animation {
    color: white;
    max-height: 375px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: left;
    align-self: self-end;
    position: relative;
    top: -25px;
    left: -5.8em;
  }

  .teste {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    display: block;
    width: 100%;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    align-self: self-start;
  }

  .Aforismo2_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo2_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo3_line {
    background-color: white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: right;
    max-height: 150px;
    height: 100%;
    max-width: 20px;
    width: 100%;
    position: relative;
    top: 1.2em;
    right: 7em;
  }

  .Aforismo3_animation {
    color: white;
    max-height: 190px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: center;
  }

  .Aforismo3_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo3_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo3_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 100%;
    width: 100%;
  }

  .Aforismo4_animation {
    color: white;
    max-height: 90%;
    height: auto;
    width: auto;
    grid-row: 1 / 3;
    grid-column: 1 / 3;
    justify-self: right;
    align-self: center;
  }

  .Aforismo4_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo4_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .Aforismo5_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center;
  }

  .Aforismos5_animation_grid {
    grid-column: 1 / 3;
    color: white;
    width: -moz-fit-content;
    width: fit-content;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: left;
    align-items: baseline;
  }

  .Aforismo5_animation_1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_animation_2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo5_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo5_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo5_img img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo6_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo6_animation {
    grid-column: 1 / 5;
    color: white;
    max-width: 209px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }

  .Aforismo6_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo6_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo6_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo6_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 90%;
    width: 100%;
  }

  .Aforismo7_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo7_animation {
    grid-column: 1 / 3;
    color: white;
    height: 250px;
    width: auto;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: block !important;
  }

  .Aforismo7_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo7_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo7_img {
    width: 100dvw;
    height: 100dvh;
  }

  .Aforismo7_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo8_grid_title {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    height: 100%;
    justify-content: center;
    align-content: center;
  }

  .Aforismo8_title1 {
    grid-column: 1 / 2;
    color: white;
    justify-self: right;
  }

  .Aforismo8_title2 {
    grid-column: 2 / 3;
    color: white;
    justify-self: left;
  }

  .Aforismo8_animation1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: right;
    position: relative;
    right: 2em;
  }

  .Aforismo8_animation2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: left;
    position: relative;
    right: 3em;
  }

  .Aforismo8_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo8_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo8_img {
    height: 100dvh;
    width: 100dvw;
  }

  .Aforismo8_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo9_animation {
    grid-column: 1 / 3;
    color: white;
    max-width: 650px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }
}

@media all and (min-width: 376px) and (max-width: 425px) {
  .TheorySection h1 {
    font-size: 21px;
    font-weight: bolder;
    margin: 0;
  }

  .TheorySection p {
    font-size: 21px;
    font-weight: normal;
    margin: 0;
  }

  .Aforismo1_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo1_animation {
    color: white;
    border-left: 1px solid white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: left;
    align-self: self-start;
    height: 75%;
    width: 1px;
  }

  .Aforismo1_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
    font-weight: bolder;
  }

  .Aforismo1_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo1_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo1_img img {
    object-fit: cover;
    object-position: 50% 90%;
    height: 100%;
    width: 100%;
  }

  .Aforismo1_img_info {
    color: White;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 5.25%;
    height: 100vh;
    align-items: end;
    padding-bottom: 1.5em;
    z-index: 100;
  }

  .Aforismo1_img_info div {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    width: 100%;
  }

  .Aforismo2_animation {
    color: white;
    max-height: 375px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: left;
    align-self: self-end;
    position: relative;
    top: -25px;
    left: -5.8em;
  }

  .teste {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    display: block;
    width: 100%;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    align-self: self-start;
  }

  .Aforismo2_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo2_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo3_line {
    background-color: white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: right;
    max-height: 150px;
    height: 100%;
    max-width: 20px;
    width: 100%;
    position: relative;
    top: 1.2em;
    right: 7em;
  }

  .Aforismo3_animation {
    color: white;
    max-height: 190px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: center;
  }

  .Aforismo3_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo3_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo3_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 90%;
    width: 90%;
  }

  .Aforismo4_animation {
    color: white;
    max-height: 90%;
    height: auto;
    width: auto;
    grid-row: 1 / 3;
    grid-column: 1 / 3;
    justify-self: right;
    align-self: center;
  }

  .Aforismo4_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo4_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .Aforismo5_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center;
  }

  .Aforismos5_animation_grid {
    grid-column: 1 / 3;
    color: white;
    width: -moz-fit-content;
    width: fit-content;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: left;
    align-items: baseline;
  }

  .Aforismo5_animation_1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_animation_2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo5_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo5_img {
    width: 100dvw;
    height: 100dvh;
  }

  .Aforismo5_img img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo6_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo6_animation {
    grid-column: 1 / 5;
    color: white;
    max-width: 209px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }

  .Aforismo6_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo6_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo6_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo6_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 90%;
    width: 90%;
  }

  .Aforismo7_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo7_animation {
    grid-column: 1 / 3;
    color: white;
    height: 250px;
    width: auto;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: block !important;
  }

  .Aforismo7_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo7_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo7_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo7_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo8_grid_title {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    height: 100%;
    justify-content: center;
    align-content: center;
  }

  .Aforismo8_title1 {
    grid-column: 1 / 2;
    color: white;
    justify-self: right;
  }

  .Aforismo8_title2 {
    grid-column: 2 / 3;
    color: white;
    justify-self: left;
  }

  .Aforismo8_animation1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: right;
    position: relative;
    right: 2em;
  }

  .Aforismo8_animation2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: left;
    position: relative;
    right: 3em;
  }

  .Aforismo8_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo8_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo8_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo8_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo9_animation {
    grid-column: 1 / 3;
    color: white;
    max-width: 650px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }
}

@media all and (min-width: 321px) and (max-width: 375px) {
  .TheorySection h1 {
    font-size: 21px;
    font-weight: bolder;
    margin: 0;
  }

  .TheorySection p {
    font-size: 21px;
    font-weight: normal;
    margin: 0;
  }

  .Aforismo1_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo1_animation {
    color: white;
    border-left: 1px solid white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: left;
    align-self: self-start;
    height: 75%;
    width: 1px;
  }

  .Aforismo1_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
    font-weight: bolder;
  }

  .Aforismo1_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo1_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo1_img img {
    object-fit: cover;
    object-position: 50% 90%;
    height: 100%;
    width: 100%;
  }

  .Aforismo1_img_info {
    color: White;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 5.25%;
    height: 100vh;
    align-items: end;
    padding-bottom: 1.5em;
    z-index: 100;
  }

  .Aforismo1_img_info div {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    width: 100%;
  }

  .Aforismo2_animation {
    color: white;
    max-height: 375px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: left;
    align-self: self-end;
    position: relative;
    top: -25px;
    left: -5.8em;
  }

  .teste {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    display: block;
    width: 100%;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    align-self: self-start;
  }

  .Aforismo2_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo2_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo3_line {
    background-color: white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: right;
    max-height: 150px;
    height: 100%;
    max-width: 20px;
    width: 100%;
    position: relative;
    top: 1.2em;
    right: 7em;
  }

  .Aforismo3_animation {
    color: white;
    max-height: 190px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: center;
  }

  .Aforismo3_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo3_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo3_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 90%;
    width: 90%;
  }

  .Aforismo4_animation {
    color: white;
    max-height: 90%;
    height: auto;
    width: auto;
    grid-row: 1 / 3;
    grid-column: 1 / 3;
    justify-self: right;
    align-self: center;
  }

  .Aforismo4_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo4_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .Aforismo5_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center;
  }

  .Aforismos5_animation_grid {
    grid-column: 1 / 3;
    color: white;
    width: -moz-fit-content;
    width: fit-content;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: left;
    align-items: baseline;
  }

  .Aforismo5_animation_1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_animation_2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo5_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo5_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo5_img img {
    object-fit: cover;
    object-position: center;
    height: 95%;
    width: 100%;
  }

  .Aforismo6_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo6_animation {
    grid-column: 1 / 5;
    color: white;
    max-width: 209px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }

  .Aforismo6_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo6_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo6_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo6_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 90%;
    width: 90%;
  }

  .Aforismo7_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo7_animation {
    grid-column: 1 / 3;
    color: white;
    height: 250px;
    width: auto;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: block !important;
  }

  .Aforismo7_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo7_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo7_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo7_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo8_grid_title {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    height: 100%;
    justify-content: center;
    align-content: center;
  }

  .Aforismo8_title1 {
    grid-column: 1 / 2;
    color: white;
    justify-self: right;
  }

  .Aforismo8_title2 {
    grid-column: 2 / 3;
    color: white;
    justify-self: left;
  }

  .Aforismo8_animation1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: right;
    position: relative;
    right: 2em;
  }

  .Aforismo8_animation2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: left;
    position: relative;
    right: 3em;
  }

  .Aforismo8_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo8_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo8_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo8_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo9_animation {
    grid-column: 1 / 3;
    color: white;
    max-width: 650px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }
}

@media all and (max-width: 320px) {
  .TheorySection h1 {
    font-size: 21px;
    font-weight: bolder;
    margin: 0;
  }

  .TheorySection p {
    font-size: 21px;
    font-weight: normal;
    margin: 0;
  }

  .Aforismo1_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo1_animation {
    color: white;
    border-left: 1px solid white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: left;
    align-self: self-start;
    height: 75%;
    width: 1px;
  }

  .Aforismo1_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
    font-weight: bolder;
  }

  .Aforismo1_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo1_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo1_img img {
    object-fit: cover;
    object-position: 50% 90%;
    height: 100%;
    width: 100%;
  }

  .Aforismo1_img_info {
    color: White;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 5.25%;
    height: 100vh;
    align-items: end;
    padding-bottom: 1.5em;
    z-index: 100;
  }

  .Aforismo1_img_info div {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    width: 100%;
  }

  .Aforismo2_animation {
    color: white;
    max-height: 375px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: left;
    align-self: self-end;
    position: relative;
    top: -25px;
    left: -5.8em;
  }

  .teste {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    display: block;
    width: 100%;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    align-self: self-start;
  }

  .Aforismo2_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo2_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center !important;
  }

  .Aforismo3_line {
    background-color: white;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    justify-self: right;
    max-height: 150px;
    height: 100%;
    max-width: 20px;
    width: 100%;
    position: relative;
    top: 1.2em;
    right: 7em;
  }

  .Aforismo3_animation {
    color: white;
    max-height: 190px;
    height: 100%;
    width: auto;
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    justify-self: center;
  }

  .Aforismo3_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo3_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo3_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo3_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 90%;
    width: 90%;
  }

  .Aforismo4_animation {
    color: white;
    max-height: 90%;
    height: auto;
    width: auto;
    grid-row: 1 / 3;
    grid-column: 1 / 3;
    justify-self: right;
    align-self: center;
  }

  .Aforismo4_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo4_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .Aforismo5_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: left;
    align-items: center;
  }

  .Aforismos5_animation_grid {
    grid-column: 1 / 3;
    color: white;
    width: -moz-fit-content;
    width: fit-content;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: left;
    align-items: baseline;
  }

  .Aforismo5_animation_1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_animation_2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    max-height: 100px;
    width: auto;
    align-self: self-start;
  }

  .Aforismo5_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo5_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo5_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo5_img img {
    object-fit: cover;
    object-position: center;
    height: 90%;
    width: 100%;
  }

  .Aforismo6_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo6_animation {
    grid-column: 1 / 5;
    color: white;
    max-width: 209px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }

  .Aforismo6_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo6_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo6_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo6_img img {
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
    padding-top: 1.5em;
    height: 85%;
    width: 100%;
  }

  .Aforismo7_elements {
    height: 100dvh;
    width: 100svw;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: center;
    align-items: center;
  }

  .Aforismo7_animation {
    grid-column: 1 / 3;
    color: white;
    height: 250px;
    width: auto;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: block !important;
  }

  .Aforismo7_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo7_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo7_img {
    width: 100svw;
    height: 100dvh;
  }

  .Aforismo7_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo8_grid_title {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    height: 100%;
    justify-content: center;
    align-content: center;
  }

  .Aforismo8_title1 {
    grid-column: 1 / 2;
    color: white;
    justify-self: right;
  }

  .Aforismo8_title2 {
    grid-column: 2 / 3;
    color: white;
    justify-self: left;
  }

  .Aforismo8_animation1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: right;
    position: relative;
    right: 2em;
  }

  .Aforismo8_animation2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    color: white;
    height: 200px;
    width: auto;
    justify-self: left;
    position: relative;
    right: 3em;
  }

  .Aforismo8_text_title {
    color: white;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    align-self: self-end;
    position: relative;
    bottom: 25px;
  }

  .Aforismo8_text_body {
    color: white;
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    align-self: self-start;
  }

  .Aforismo8_img {
    height: 100dvh;
    width: 100svw;
  }

  .Aforismo8_img img {
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }

  .Aforismo9_animation {
    grid-column: 1 / 3;
    color: white;
    max-width: 650px;
    width: 100%;
    height: auto;
    justify-self: center;
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Theory2.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sCAAsC;EACtC,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;;GAOC;EACD,oBAAoB,EAAE,sEAAsE;AAC9F;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kCAAkC;EAClC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sCAAsC;EACtC,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY,EAAE,4CAA4C;AAC5D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,6BAA6B,EAAE,wCAAwC;EACvE,sBAAsB,EAAE,kDAAkD;EAC1E,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,WAAW;;AAEX;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":["html {\r\n  scroll-snap-type: y mandatory !important;\r\n}\r\n\r\n.AforismosFooter {\r\n  display: grid;\r\n  grid-template-rows: 1fr;\r\n  align-items: center;\r\n  height: 100dvh;\r\n}\r\n\r\n.AforismosFooter h1 {\r\n  align-self: center;\r\n  justify-self: center;\r\n  color: white;\r\n}\r\n\r\n.TheorySection {\r\n  scroll-snap-align: start;\r\n  perspective: 500px;\r\n  height: 100dvh;\r\n}\r\n\r\n.TheorySection > div {\r\n  overflow: hidden;\r\n}\r\n\r\n.TheorySection h1 {\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n  margin: 0;\r\n}\r\n\r\n.TheorySection p {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n  margin: 0;\r\n}\r\n\r\n.TheoryAforismoSection {\r\n  scroll-snap-align: start;\r\n  perspective: 500px;\r\n  height: 100dvh;\r\n}\r\n\r\n.TheoryAforismoSection > div {\r\n  overflow: hidden;\r\n}\r\n\r\n.TheoryAforismoSection h1 {\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n  margin: 0;\r\n}\r\n\r\n.TheoryAforismoSection p {\r\n  margin: 0;\r\n}\r\n\r\n.Aforismo1_img_info h1 {\r\n  font-size: 18px !important;\r\n}\r\n\r\n.Aforismo1_img_info p {\r\n  font-size: 18px !important;\r\n}\r\n\r\n.Theory__Aforismos2 p {\r\n  font-size: 18px;\r\n  margin: 0;\r\n}\r\n\r\n.Theory__Aforismos2 {\r\n  min-height: 100dvh;\r\n  min-width: 100dvw;\r\n  height: 100%;\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.Starting-screen {\r\n  height: 100dvh;\r\n  margin-top: 0.5em;\r\n  margin-bottom: 0.5em;\r\n  display: grid;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Starting-screen h1 {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n}\r\n\r\n.Aforismo1 {\r\n  height: 200dvh;\r\n}\r\n\r\n.Aforismo1_elements {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-template-rows: 1fr 1fr;\r\n  grid-column-gap: 20px;\r\n  grid-row-gap: 0px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: left;\r\n  align-items: center !important;\r\n}\r\n\r\n.Aforismo1_animation {\r\n  color: white;\r\n  border-left: 1px solid white;\r\n  grid-row: 1 / 2;\r\n  grid-column: 2 / 3;\r\n  justify-self: left;\r\n  align-self: self-start;\r\n  height: 97.5%;\r\n  width: 1px;\r\n}\r\n\r\n.Aforismo1_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo1_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo1_img {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.gradient-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-image: linear-gradient(\r\n    to bottom,\r\n    rgba(0, 0, 0, 0.45) 0%,\r\n    rgba(0, 0, 0, 0.2) 15%,\r\n    rgba(0, 0, 0, 0.15) 50%,\r\n    rgba(0, 0, 0, 0.2) 85%,\r\n    rgba(0, 0, 0, 0.45) 100%\r\n  );\r\n  pointer-events: none; /* This ensures that the overlay doesn't interfere with mouse events */\r\n}\r\n\r\n.Aforismo1_img img {\r\n  object-fit: cover;\r\n  object-position: 50% 90%;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.Aforismo1_img_info {\r\n  color: White;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-column-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 15.7%;\r\n  height: 100vh;\r\n  align-items: end;\r\n  padding-bottom: 1.5em;\r\n  z-index: 100;\r\n}\r\n\r\n.Aforismo1_img_info h1 {\r\n  grid-column: 3 / 5;\r\n  grid-row: 1 / 2;\r\n  width: 100%;\r\n}\r\n\r\n.Aforismo1_img_info p {\r\n  grid-column: 3 / 5;\r\n  grid-row: 1 / 2;\r\n  width: 100%;\r\n}\r\n\r\n.Aforismo2_animation {\r\n  color: white;\r\n  max-height: 325px;\r\n  height: 100%;\r\n  width: auto;\r\n  grid-row: 1 / 2;\r\n  grid-column: 1 / 3;\r\n  justify-self: center;\r\n  align-self: self-end;\r\n  position: relative;\r\n  top: 3.15em;\r\n  left: 5.6em;\r\n  margin-right: 20px;\r\n}\r\n\r\n.teste {\r\n  grid-row: 2 / 3;\r\n  grid-column: 2 / 5;\r\n  display: grid;\r\n  width: 100%;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  gap: 20px;\r\n  align-self: flex-start;\r\n}\r\n\r\n.Aforismo2_text_title {\r\n  color: white;\r\n  grid-column: 1 / 2;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo2_text_body {\r\n  color: white;\r\n  grid-column: 2 / 4;\r\n  grid-row: 1 / 2;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo3_elements {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: left;\r\n  align-items: center !important;\r\n}\r\n\r\n.Aforismo3_line {\r\n  background-color: white;\r\n  grid-row: 1 / 2;\r\n  grid-column: 2 / 3;\r\n  justify-self: right;\r\n  max-height: 150px;\r\n  height: 100%;\r\n  max-width: 20px;\r\n  width: 100%;\r\n  position: relative;\r\n  top: 1.2em;\r\n  right: 7em;\r\n}\r\n\r\n.Aforismo3_animation {\r\n  color: white;\r\n  max-height: 190px;\r\n  height: 100%;\r\n  width: auto;\r\n  grid-row: 1 / 2;\r\n  grid-column: 2 / 4;\r\n  justify-self: center;\r\n}\r\n\r\n.Aforismo3_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo3_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo3_img {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.Aforismo3_img img {\r\n  object-fit: contain;\r\n  object-position: center;\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  width: 90%;\r\n}\r\n\r\n.Aforismo4_animation {\r\n  color: white;\r\n  height: 90%;\r\n  width: auto;\r\n  grid-row: 1 / 3;\r\n  grid-column: 1 / 3;\r\n  justify-self: right;\r\n  align-self: center;\r\n}\r\n\r\n.Aforismo4_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo4_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo5 {\r\n  height: 300dvh;\r\n}\r\n\r\n.Aforismo5_elements {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-template-rows: 1fr 1fr;\r\n  grid-column-gap: 20px;\r\n  grid-row-gap: 0px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.Aforismos5_animation_grid {\r\n  grid-column: 3 / 5;\r\n  grid-row: 1 / 3;\r\n  color: white;\r\n  width: fit-content;\r\n  height: auto;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  justify-content: left;\r\n  align-items: baseline;\r\n}\r\n\r\n.Aforismo5_animation_1 {\r\n  grid-column: 1 / 2;\r\n  max-height: 133.85px;\r\n  width: auto;\r\n  align-self: baseline;\r\n}\r\n\r\n.Aforismo5_animation_2 {\r\n  grid-column: 2 / 3;\r\n  max-height: 133.85px;\r\n  width: auto;\r\n  align-self: baseline;\r\n}\r\n\r\n.Aforismo5_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo5_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo5_img {\r\n  width: 100dvw;\r\n  height: 100dvh;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.Aforismo5_img img {\r\n  object-fit: cover;\r\n  object-position: center;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.Aforismo6 {\r\n  height: 300dvh;\r\n}\r\n\r\n/* src/MouseParallax.css */\r\n.mouse-parallax-container {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  z-index: 10;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.background-blurred {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  filter: blur(2px); /* Add a blur effect to the background */\r\n}\r\n\r\n.background-unblurred {\r\n  position: relative;\r\n  top: -100dvh;\r\n  width: 100%;\r\n  height: 100%;\r\n  filter: none; /* No blur effect on the unblurred content */\r\n}\r\n\r\n.mouse-cursor {\r\n  position: absolute;\r\n  width: 100px;\r\n  height: 100px;\r\n  border-radius: 50%;\r\n  pointer-events: none;\r\n  transform: translate(-50%, -50%);\r\n  border: 2px solid transparent; /* Set border initially to transparent */\r\n  box-sizing: border-box; /* Ensure border is included in width and height */\r\n  z-index: 100;\r\n}\r\n\r\n.Aforismo6_elements {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Aforismo6_animation {\r\n  grid-column: 1 / 5;\r\n  color: white;\r\n  max-width: 209px;\r\n  width: 100%;\r\n  height: auto;\r\n  justify-self: center;\r\n  align-self: center;\r\n}\r\n\r\n.Aforismo6_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo6_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo6_img {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.Aforismo6_img img {\r\n  object-fit: contain;\r\n  object-position: center;\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  width: 90%;\r\n}\r\n\r\n.Aforismo7 {\r\n  height: 300dvh;\r\n}\r\n\r\n.Aforismo7_elements {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Aforismo7_animation {\r\n  grid-column: 1 / 5;\r\n  color: white;\r\n  height: 300px;\r\n  width: auto;\r\n  justify-self: center;\r\n}\r\n\r\n.cursor {\r\n  background-color: #ffffff;\r\n  height: 60px;\r\n  width: 60px;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  pointer-events: none;\r\n  display: block !important;\r\n}\r\n\r\n.Aforismo7_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo7_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo7_img {\r\n  width: 100dvw;\r\n  height: 100dvh;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.Aforismo7_img img {\r\n  object-fit: cover;\r\n  object-position: center;\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.Aforismo8 {\r\n  height: 400dvh;\r\n}\r\n\r\n.Aforismo8_grid_title {\r\n  grid-column: 2 / 4;\r\n  grid-row: 2 / 3;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-gap: 20px;\r\n  height: 100%;\r\n  justify-content: center;\r\n  align-content: start;\r\n}\r\n\r\n.Aforismo8_title1 {\r\n  grid-column: 1 / 2;\r\n  color: white;\r\n  justify-self: right;\r\n}\r\n\r\n.Aforismo8_title2 {\r\n  grid-column: 2 / 3;\r\n  color: white;\r\n  justify-self: left;\r\n}\r\n\r\n.Aforismo8_animation1 {\r\n  grid-column: 2 / 3;\r\n  grid-row: 1 / 2;\r\n  color: white;\r\n  height: 150px;\r\n  width: auto;\r\n  justify-self: right;\r\n  position: relative;\r\n  right: 1.5em;\r\n}\r\n\r\n.Aforismo8_animation2 {\r\n  grid-column: 3 / 4;\r\n  grid-row: 1 / 2;\r\n  color: white;\r\n  height: 150px;\r\n  width: auto;\r\n  justify-self: left;\r\n  position: relative;\r\n  right: 3em;\r\n}\r\n\r\n.Aforismo8_text_title {\r\n  color: white;\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo8_text_body {\r\n  color: white;\r\n  grid-column: 3 / 5;\r\n  grid-row: 2 / 3;\r\n  align-self: self-start;\r\n}\r\n\r\n.Aforismo8_img {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.Aforismo8_img img {\r\n  object-fit: cover;\r\n  object-position: center;\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.Aforismo9_animation {\r\n  grid-column: 2 / 4;\r\n  color: white;\r\n  max-width: 650px;\r\n  width: 100%;\r\n  height: auto;\r\n  justify-self: center;\r\n  align-self: center;\r\n}\r\n\r\n.Aforismo9_img {\r\n  height: 100dvh;\r\n  width: 100dvw;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.Aforismo9_img img {\r\n  object-fit: cover;\r\n  object-position: center;\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n@media all and (min-width: 1921px) {\r\n}\r\n\r\n@media all and (min-width: 1441px) and (max-width: 1920px) {\r\n}\r\n\r\n@media all and (min-width: 1025px) and (max-width: 1440px) {\r\n  .Aforismo1_elements {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .Aforismo3_elements {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .Aforismo5_elements {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .Aforismo6_elements {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .Aforismo7_elements {\r\n    max-width: 80%;\r\n  }\r\n}\r\n\r\n/* mobile */\r\n\r\n@media all and (min-width: 769px) and (max-width: 1024px) {\r\n  .TheorySection h1 {\r\n    font-size: 21px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .TheorySection p {\r\n    font-size: 21px;\r\n    font-weight: normal;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo1_elements {\r\n    height: 100dvh;\r\n    width: 100dvw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo1_animation {\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n    height: 75%;\r\n    width: 1px;\r\n  }\r\n\r\n  .Aforismo1_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n    font-weight: bolder;\r\n  }\r\n\r\n  .Aforismo1_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo1_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo1_img img {\r\n    object-fit: cover;\r\n    object-position: 50% 90%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo1_img_info {\r\n    color: White;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    height: 100vh;\r\n    align-items: end;\r\n    padding-bottom: 1.5em;\r\n    z-index: 100;\r\n  }\r\n\r\n  .Aforismo1_img_info div {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo2_animation {\r\n    color: white;\r\n    max-height: 375px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: left;\r\n    align-self: self-end;\r\n    position: relative;\r\n    top: -25px;\r\n    left: -5.8em;\r\n  }\r\n\r\n  .teste {\r\n    grid-row: 2 / 3;\r\n    grid-column: 1 / 3;\r\n    display: block;\r\n    width: 100%;\r\n    grid-template-rows: 1fr 1fr;\r\n    gap: 20px;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo2_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo2_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo3_line {\r\n    background-color: white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: right;\r\n    max-height: 150px;\r\n    height: 100%;\r\n    max-width: 20px;\r\n    width: 100%;\r\n    position: relative;\r\n    top: 1.2em;\r\n    right: 7em;\r\n  }\r\n\r\n  .Aforismo3_animation {\r\n    color: white;\r\n    max-height: 190px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Aforismo3_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo3_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_img {\r\n    height: 100dvh;\r\n    width: 100dvw;\r\n  }\r\n\r\n  .Aforismo3_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 89.5%;\r\n  }\r\n\r\n  .Aforismo4_animation {\r\n    color: white;\r\n    height: 90%;\r\n    width: auto;\r\n    grid-row: 1 / 3;\r\n    grid-column: 1 / 3;\r\n    justify-self: right;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo4_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo4_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n    background-color: rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .Aforismo5_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismos5_animation_grid {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    width: fit-content;\r\n    height: auto;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-content: left;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .Aforismo5_animation_1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_animation_2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo5_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo5_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo6_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo6_animation {\r\n    grid-column: 1 / 5;\r\n    color: white;\r\n    max-width: 209px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo6_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo6_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo6_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo6_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 5%;\r\n    height: 95%;\r\n    width: 89.5%;\r\n  }\r\n\r\n  .Aforismo7_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo7_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    pointer-events: none;\r\n    display: block !important;\r\n  }\r\n\r\n  .Aforismo7_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo7_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo7_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo7_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo8_grid_title {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-content: center;\r\n  }\r\n\r\n  .Aforismo8_title1 {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    justify-self: right;\r\n  }\r\n\r\n  .Aforismo8_title2 {\r\n    grid-column: 2 / 3;\r\n    color: white;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Aforismo8_animation1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: right;\r\n    position: relative;\r\n    right: 2em;\r\n  }\r\n\r\n  .Aforismo8_animation2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: left;\r\n    position: relative;\r\n    right: 3em;\r\n  }\r\n\r\n  .Aforismo8_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo8_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo8_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo8_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo9_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    max-width: 650px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 426px) and (max-width: 768px) {\r\n  .TheorySection h1 {\r\n    font-size: 21px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .TheorySection p {\r\n    font-size: 21px;\r\n    font-weight: normal;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo1_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo1_animation {\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n    height: 75%;\r\n    width: 1px;\r\n  }\r\n\r\n  .Aforismo1_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n    font-weight: bolder;\r\n  }\r\n\r\n  .Aforismo1_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo1_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo1_img img {\r\n    object-fit: cover;\r\n    object-position: 50% 90%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo1_img_info {\r\n    color: White;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    height: 100vh;\r\n    align-items: end;\r\n    padding-bottom: 1.5em;\r\n    z-index: 100;\r\n  }\r\n\r\n  .Aforismo1_img_info div {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo2_animation {\r\n    color: white;\r\n    max-height: 375px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: left;\r\n    align-self: self-end;\r\n    position: relative;\r\n    top: -25px;\r\n    left: -5.8em;\r\n  }\r\n\r\n  .teste {\r\n    grid-row: 2 / 3;\r\n    grid-column: 1 / 3;\r\n    display: block;\r\n    width: 100%;\r\n    grid-template-rows: 1fr 1fr;\r\n    gap: 20px;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo2_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo2_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo3_line {\r\n    background-color: white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: right;\r\n    max-height: 150px;\r\n    height: 100%;\r\n    max-width: 20px;\r\n    width: 100%;\r\n    position: relative;\r\n    top: 1.2em;\r\n    right: 7em;\r\n  }\r\n\r\n  .Aforismo3_animation {\r\n    color: white;\r\n    max-height: 190px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Aforismo3_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo3_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo3_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo4_animation {\r\n    color: white;\r\n    max-height: 90%;\r\n    height: auto;\r\n    width: auto;\r\n    grid-row: 1 / 3;\r\n    grid-column: 1 / 3;\r\n    justify-self: right;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo4_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo4_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n    background-color: rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .Aforismo5_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismos5_animation_grid {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    width: fit-content;\r\n    height: auto;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-content: left;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .Aforismo5_animation_1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_animation_2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo5_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo5_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo6_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo6_animation {\r\n    grid-column: 1 / 5;\r\n    color: white;\r\n    max-width: 209px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo6_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo6_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo6_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo6_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 90%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo7_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo7_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    pointer-events: none;\r\n    display: block !important;\r\n  }\r\n\r\n  .Aforismo7_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo7_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo7_img {\r\n    width: 100dvw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo7_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo8_grid_title {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-content: center;\r\n  }\r\n\r\n  .Aforismo8_title1 {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    justify-self: right;\r\n  }\r\n\r\n  .Aforismo8_title2 {\r\n    grid-column: 2 / 3;\r\n    color: white;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Aforismo8_animation1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: right;\r\n    position: relative;\r\n    right: 2em;\r\n  }\r\n\r\n  .Aforismo8_animation2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: left;\r\n    position: relative;\r\n    right: 3em;\r\n  }\r\n\r\n  .Aforismo8_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo8_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo8_img {\r\n    height: 100dvh;\r\n    width: 100dvw;\r\n  }\r\n\r\n  .Aforismo8_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo9_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    max-width: 650px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 376px) and (max-width: 425px) {\r\n  .TheorySection h1 {\r\n    font-size: 21px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .TheorySection p {\r\n    font-size: 21px;\r\n    font-weight: normal;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo1_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo1_animation {\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n    height: 75%;\r\n    width: 1px;\r\n  }\r\n\r\n  .Aforismo1_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n    font-weight: bolder;\r\n  }\r\n\r\n  .Aforismo1_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo1_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo1_img img {\r\n    object-fit: cover;\r\n    object-position: 50% 90%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo1_img_info {\r\n    color: White;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    height: 100vh;\r\n    align-items: end;\r\n    padding-bottom: 1.5em;\r\n    z-index: 100;\r\n  }\r\n\r\n  .Aforismo1_img_info div {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo2_animation {\r\n    color: white;\r\n    max-height: 375px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: left;\r\n    align-self: self-end;\r\n    position: relative;\r\n    top: -25px;\r\n    left: -5.8em;\r\n  }\r\n\r\n  .teste {\r\n    grid-row: 2 / 3;\r\n    grid-column: 1 / 3;\r\n    display: block;\r\n    width: 100%;\r\n    grid-template-rows: 1fr 1fr;\r\n    gap: 20px;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo2_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo2_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo3_line {\r\n    background-color: white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: right;\r\n    max-height: 150px;\r\n    height: 100%;\r\n    max-width: 20px;\r\n    width: 100%;\r\n    position: relative;\r\n    top: 1.2em;\r\n    right: 7em;\r\n  }\r\n\r\n  .Aforismo3_animation {\r\n    color: white;\r\n    max-height: 190px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Aforismo3_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo3_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo3_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 90%;\r\n    width: 90%;\r\n  }\r\n\r\n  .Aforismo4_animation {\r\n    color: white;\r\n    max-height: 90%;\r\n    height: auto;\r\n    width: auto;\r\n    grid-row: 1 / 3;\r\n    grid-column: 1 / 3;\r\n    justify-self: right;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo4_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo4_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n    background-color: rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .Aforismo5_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismos5_animation_grid {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    width: fit-content;\r\n    height: auto;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-content: left;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .Aforismo5_animation_1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_animation_2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo5_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_img {\r\n    width: 100dvw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo5_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo6_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo6_animation {\r\n    grid-column: 1 / 5;\r\n    color: white;\r\n    max-width: 209px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo6_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo6_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo6_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo6_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 90%;\r\n    width: 90%;\r\n  }\r\n\r\n  .Aforismo7_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo7_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    pointer-events: none;\r\n    display: block !important;\r\n  }\r\n\r\n  .Aforismo7_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo7_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo7_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo7_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo8_grid_title {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-content: center;\r\n  }\r\n\r\n  .Aforismo8_title1 {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    justify-self: right;\r\n  }\r\n\r\n  .Aforismo8_title2 {\r\n    grid-column: 2 / 3;\r\n    color: white;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Aforismo8_animation1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: right;\r\n    position: relative;\r\n    right: 2em;\r\n  }\r\n\r\n  .Aforismo8_animation2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: left;\r\n    position: relative;\r\n    right: 3em;\r\n  }\r\n\r\n  .Aforismo8_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo8_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo8_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo8_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo9_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    max-width: 650px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 321px) and (max-width: 375px) {\r\n  .TheorySection h1 {\r\n    font-size: 21px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .TheorySection p {\r\n    font-size: 21px;\r\n    font-weight: normal;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo1_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo1_animation {\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n    height: 75%;\r\n    width: 1px;\r\n  }\r\n\r\n  .Aforismo1_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n    font-weight: bolder;\r\n  }\r\n\r\n  .Aforismo1_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo1_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo1_img img {\r\n    object-fit: cover;\r\n    object-position: 50% 90%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo1_img_info {\r\n    color: White;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    height: 100vh;\r\n    align-items: end;\r\n    padding-bottom: 1.5em;\r\n    z-index: 100;\r\n  }\r\n\r\n  .Aforismo1_img_info div {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo2_animation {\r\n    color: white;\r\n    max-height: 375px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: left;\r\n    align-self: self-end;\r\n    position: relative;\r\n    top: -25px;\r\n    left: -5.8em;\r\n  }\r\n\r\n  .teste {\r\n    grid-row: 2 / 3;\r\n    grid-column: 1 / 3;\r\n    display: block;\r\n    width: 100%;\r\n    grid-template-rows: 1fr 1fr;\r\n    gap: 20px;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo2_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo2_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo3_line {\r\n    background-color: white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: right;\r\n    max-height: 150px;\r\n    height: 100%;\r\n    max-width: 20px;\r\n    width: 100%;\r\n    position: relative;\r\n    top: 1.2em;\r\n    right: 7em;\r\n  }\r\n\r\n  .Aforismo3_animation {\r\n    color: white;\r\n    max-height: 190px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Aforismo3_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo3_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo3_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 90%;\r\n    width: 90%;\r\n  }\r\n\r\n  .Aforismo4_animation {\r\n    color: white;\r\n    max-height: 90%;\r\n    height: auto;\r\n    width: auto;\r\n    grid-row: 1 / 3;\r\n    grid-column: 1 / 3;\r\n    justify-self: right;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo4_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo4_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n    background-color: rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .Aforismo5_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismos5_animation_grid {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    width: fit-content;\r\n    height: auto;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-content: left;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .Aforismo5_animation_1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_animation_2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo5_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo5_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 95%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo6_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo6_animation {\r\n    grid-column: 1 / 5;\r\n    color: white;\r\n    max-width: 209px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo6_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo6_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo6_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo6_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 90%;\r\n    width: 90%;\r\n  }\r\n\r\n  .Aforismo7_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo7_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    pointer-events: none;\r\n    display: block !important;\r\n  }\r\n\r\n  .Aforismo7_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo7_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo7_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo7_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo8_grid_title {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-content: center;\r\n  }\r\n\r\n  .Aforismo8_title1 {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    justify-self: right;\r\n  }\r\n\r\n  .Aforismo8_title2 {\r\n    grid-column: 2 / 3;\r\n    color: white;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Aforismo8_animation1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: right;\r\n    position: relative;\r\n    right: 2em;\r\n  }\r\n\r\n  .Aforismo8_animation2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: left;\r\n    position: relative;\r\n    right: 3em;\r\n  }\r\n\r\n  .Aforismo8_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo8_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo8_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo8_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo9_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    max-width: 650px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 320px) {\r\n  .TheorySection h1 {\r\n    font-size: 21px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .TheorySection p {\r\n    font-size: 21px;\r\n    font-weight: normal;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo1_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo1_animation {\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n    height: 75%;\r\n    width: 1px;\r\n  }\r\n\r\n  .Aforismo1_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n    font-weight: bolder;\r\n  }\r\n\r\n  .Aforismo1_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo1_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo1_img img {\r\n    object-fit: cover;\r\n    object-position: 50% 90%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo1_img_info {\r\n    color: White;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    height: 100vh;\r\n    align-items: end;\r\n    padding-bottom: 1.5em;\r\n    z-index: 100;\r\n  }\r\n\r\n  .Aforismo1_img_info div {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo2_animation {\r\n    color: white;\r\n    max-height: 375px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: left;\r\n    align-self: self-end;\r\n    position: relative;\r\n    top: -25px;\r\n    left: -5.8em;\r\n  }\r\n\r\n  .teste {\r\n    grid-row: 2 / 3;\r\n    grid-column: 1 / 3;\r\n    display: block;\r\n    width: 100%;\r\n    grid-template-rows: 1fr 1fr;\r\n    gap: 20px;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo2_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo2_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .Aforismo3_line {\r\n    background-color: white;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 2;\r\n    justify-self: right;\r\n    max-height: 150px;\r\n    height: 100%;\r\n    max-width: 20px;\r\n    width: 100%;\r\n    position: relative;\r\n    top: 1.2em;\r\n    right: 7em;\r\n  }\r\n\r\n  .Aforismo3_animation {\r\n    color: white;\r\n    max-height: 190px;\r\n    height: 100%;\r\n    width: auto;\r\n    grid-row: 1 / 2;\r\n    grid-column: 1 / 3;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Aforismo3_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo3_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo3_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo3_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 90%;\r\n    width: 90%;\r\n  }\r\n\r\n  .Aforismo4_animation {\r\n    color: white;\r\n    max-height: 90%;\r\n    height: auto;\r\n    width: auto;\r\n    grid-row: 1 / 3;\r\n    grid-column: 1 / 3;\r\n    justify-self: right;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo4_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo4_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n    background-color: rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .Aforismo5_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismos5_animation_grid {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    width: fit-content;\r\n    height: auto;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-content: left;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .Aforismo5_animation_1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_animation_2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    max-height: 100px;\r\n    width: auto;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo5_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo5_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo5_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 90%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo6_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo6_animation {\r\n    grid-column: 1 / 5;\r\n    color: white;\r\n    max-width: 209px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .Aforismo6_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo6_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo6_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo6_img img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    padding-top: 1.5em;\r\n    height: 85%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo7_elements {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo7_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    pointer-events: none;\r\n    display: block !important;\r\n  }\r\n\r\n  .Aforismo7_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo7_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo7_img {\r\n    width: 100svw;\r\n    height: 100dvh;\r\n  }\r\n\r\n  .Aforismo7_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo8_grid_title {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-content: center;\r\n  }\r\n\r\n  .Aforismo8_title1 {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    justify-self: right;\r\n  }\r\n\r\n  .Aforismo8_title2 {\r\n    grid-column: 2 / 3;\r\n    color: white;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Aforismo8_animation1 {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: right;\r\n    position: relative;\r\n    right: 2em;\r\n  }\r\n\r\n  .Aforismo8_animation2 {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    justify-self: left;\r\n    position: relative;\r\n    right: 3em;\r\n  }\r\n\r\n  .Aforismo8_text_title {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    align-self: self-end;\r\n    position: relative;\r\n    bottom: 25px;\r\n  }\r\n\r\n  .Aforismo8_text_body {\r\n    color: white;\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Aforismo8_img {\r\n    height: 100dvh;\r\n    width: 100svw;\r\n  }\r\n\r\n  .Aforismo8_img img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo9_animation {\r\n    grid-column: 1 / 3;\r\n    color: white;\r\n    max-width: 650px;\r\n    width: 100%;\r\n    height: auto;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
